import 'es6-promise/auto';
import Vue from 'vue';
import router from './router/index';
import store from './store/index';
import {sync} from 'vuex-router-sync';
import App from './App.vue';
import './assets/stylus/style.styl';
// import 'mint-ui/lib/style.css';

//结合vuex和路由
sync(store, router);

export const Root = new Vue({
  router,
  store,
  ...App
});

requirejs(['trace/index'],function(Trace){
    window.onerror = function(errorMsg, url, lineNumber, column, errorObj) {
        console.log('errorMsg:', errorMsg);
        console.log('url:', url);
        console.log('lineNumber:', lineNumber);
        console.log('column:', column);
        console.log('errorObj:', errorObj);
        console.log('errorObj.stack:', errorObj.stack);
        Trace.report('ERROR', `${errorMsg}, 错误位置${lineNumber}:${column}`);
    }
})

document.addEventListener('DOMContentLoaded', function () {
  // let width = document.getElementsByTagName('body')[0].getBoundingClientRect().width;

  Root.$mount('#app');
});

